import { isAxiosError } from 'axios'

export interface AuthError {
  code: string
  detail: string
}

/** Router state a failed sign-in carries to the home page, which renders it. */
export interface AuthErrorLocationState {
  authError?: AuthError
}

const GENERIC_DETAIL = "We couldn't sign you in. Please try again in a moment."

/**
 * Anything the backend didn't explain — a network drop, a 500, a missing auth
 * code — falls back to generic copy, since its raw message means nothing here.
 */
export function toAuthError(error: unknown): AuthError {
  const data = isAxiosError<Partial<AuthError>>(error) ? error.response?.data : undefined

  if (data?.detail) {
    return { code: data.code ?? '', detail: data.detail }
  }

  return { code: '', detail: GENERIC_DETAIL }
}
